import type {
  SuppressHeaderKeyboardEventParams,
  SuppressKeyboardEventParams,
} from '@ag-grid-community/core';

import { FOCUSABLE_SELECTOR } from '../shared/focusableSelector';

function suppressKeyboardEvent(
  params: SuppressKeyboardEventParams | SuppressHeaderKeyboardEventParams,
  cellSelector: string,
): boolean {
  if ('editing' in params && params.editing) return false;

  const { event } = params;
  const { key, shiftKey } = event;
  if (key !== 'Tab' && key !== 'Enter' && key !== ' ') return false;

  const cell = (event.target as HTMLElement | null)?.closest<HTMLElement>(
    cellSelector,
  );
  if (!cell) return false;

  const active = document.activeElement as HTMLElement | null;
  const isOnChildControl =
    !!active &&
    active !== cell &&
    cell.contains(active) &&
    active.matches(FOCUSABLE_SELECTOR);

  if (key !== 'Tab') return isOnChildControl;

  const focusable = Array.from(
    cell.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR),
  ).filter((element) => element.offsetParent !== null);
  if (!focusable.length) return false;

  const index = active ? focusable.indexOf(active) : -1;
  const nextIndex =
    index === -1 ? (shiftKey ? -1 : 0) : shiftKey ? index - 1 : index + 1;
  const target = focusable[nextIndex];
  if (!target) return false;

  event.preventDefault();
  target.focus();
  return true;
}

export function suppressCellKeyboardEvent(
  params: SuppressKeyboardEventParams,
): boolean {
  return suppressKeyboardEvent(params, '.ag-cell');
}

export function suppressHeaderCellKeyboardEvent(
  params: SuppressHeaderKeyboardEventParams,
): boolean {
  return suppressKeyboardEvent(params, '.ag-header-cell');
}
